



















































import Vue from 'vue'
export default Vue.extend({
    props: ['client'],
    data() {
        return {
            form: {
                id: 0,
                name: '',
                hourly_rate: 0
            },
            clientShadow: this.client,
            isEdit: !!this.client
        }
    },
    watch: {
        client(value: any) {
            this.clientShadow = value;
            
            this.populateForm(this.clientShadow);
        }
    },
    mounted() {
        this.populateForm(this.client);
    },
    methods: {
        populateForm(client: any) {
            if (client) {
                Object.assign(this.form, client);
            } else {
                this.form = {
                    id: 0,
                    name: '',
                    hourly_rate: 0
                };
            }
        },
        save() {
            const data = Object.assign({}, this.form);
            if (!this.isEdit) {
                delete data.id;
            }

            data.hourly_rate = +data.hourly_rate;

            this.form = {
                id: 0,
                name: '',
                hourly_rate: 0
            };

            this.$emit('save', data);
        },
        close() {
            this.$emit('close');
        }
    },
    computed: {
        submitText(): string {
            return this.isEdit ? 'Save' : 'Create';
        },
        actionText(): string {
            return this.isEdit ? 'Update' : 'Create';
        }
    }
})
